import styled from '@emotion/styled'
import theme from '../../../../../styles/theme'
import {
  InfoXXXSmall600Style,
  InfoMediumMini600Style,
} from '../../../../../styles/Text.styles'

export const ModelPickerContainer = styled.div`
  margin-bottom: 2rem;
`

export const StatsContainer = styled.div`
  margin-top: 1rem;
`

export const ModelInfoTitle = styled.span`
  ${InfoXXXSmall600Style};
  color: ${theme.colors.veryVeryVeryFadedText};
  margin-bottom: 0.2rem;
`

export const ModelInfoValue = styled.span`
  ${InfoMediumMini600Style};
  color: ${theme.colors.fadedText};
`
